import { productNormalizer } from './ProductNormalizer'
import type { ParsedProductHints, ProductModel } from './ProductTypes'

/**
 * ProductFingerprint — unique identity with priority:
 * 1 Part Number · 2 Brand · 3 Model · 4 Category · 5 Capacity
 */
export class ProductFingerprint {
  build(hints: ParsedProductHints): string {
    const brand = productNormalizer.slug(hints.brand || 'UNKNOWN')
    const model = productNormalizer.slug(hints.model || hints.line || 'MODEL')
    const category = productNormalizer.slug(hints.category || 'GENERAL')
    const capacity = productNormalizer.slug(hints.capacity || '')
    const part = productNormalizer.slug(hints.partNumber || '')

    if (part) {
      // Part number has absolute priority — still prefix brand for readability
      return `${brand}-${model}-${part}`.replace(/-+/g, '-').replace(/^-|-$/g, '')
    }

    const segments = [brand, model, category]
    if (capacity) segments.push(capacity)
    const tech = hints.technology[0] ? productNormalizer.slug(hints.technology[0]) : ''
    if (tech && !capacity) segments.push(tech)

    return segments.filter(Boolean).join('-').replace(/-+/g, '-')
  }

  fromProduct(product: Pick<ProductModel, 'brand' | 'model' | 'category' | 'capacity' | 'partNumber' | 'line' | 'technology'>): string {
    return this.build({
      raw: '',
      normalized: '',
      category: product.category,
      brand: product.brand,
      line: product.line,
      model: product.model,
      partNumber: product.partNumber,
      capacity: product.capacity,
      technology: product.technology ? product.technology.split('|').filter(Boolean) : [],
      attributes: {},
      tokens: [],
    })
  }

  equals(a: string, b: string): boolean {
    return productNormalizer.normalize(a) === productNormalizer.normalize(b)
  }
}

export const productFingerprint = new ProductFingerprint()
